import {useEffect, useState} from "react";
import {demandKpiPage, DemandKpiVo} from "#services/api";


// 获取所有考核指标列表,如果detailId不同则重新获取
// 缓存KPIList
let KPIList = null;
let localDetailId: any = '1';
function getKPIList(detailId: string | number) {
    if(!!KPIList && localDetailId === detailId) return KPIList;
    localDetailId = detailId;
    KPIList = demandKpiPage({
        current: 1,
        limit: 1000,
        status_list: [1]
    }).then((res) => {
        return res.data.records;
    })
    KPIList.catch(() => {
        KPIList = null;
        return []
    })
    return KPIList;
}

const useKPIList = (isEdit:boolean, detailId: string | number = '1') => {
    const [list, setList] = useState([]);
    useEffect(() => {
        if(!isEdit) return;
        getKPIList(detailId).then((res) => {
            setList(res);
        })
    }, [isEdit, detailId])
    return list as DemandKpiVo[];
}

export default useKPIList;
